module.exports = __webpack_public_path__ + "static/process-thinking-413c3d6221f40144b2a17842c65f8ad9.jpg";